import { useEffect, useState } from "react";
import ActionMobileDrop from "../../ActionDropBar/ActionMobileDrop";
import Level2SailingDateInput from "./Level2SailingDateInput";

const SailingInput = ({ data, setData }) => {
  const [activeRow, setActiveRow] = useState(0); // 👈 Track active row
  const [sailingPage, setSailingPage] = useState();
  const handleChange = (index, field, value) => {
    const updateddailyTimings = [...data.dailyTimings];
    updateddailyTimings[index][field] = value;
    setData({ ...data, dailyTimings: updateddailyTimings });
  };

  useEffect(() => {
    setSailingPage(JSON.parse(localStorage.getItem("sailing-page") || "{}"));
  }, []);

  const addRow = () => {
    setData({
      ...data,
      dailyTimings: [
        ...data.dailyTimings,
        { day: "", description: "", startTime: "", endTime: "" },
      ],
    });
    setActiveRow(data.dailyTimings.length); // 👈 new row becomes active
  };

  const deleteRow = (index) => {
    if (data.dailyTimings.length > 1) {
      const updateddailyTimings = data.dailyTimings.filter(
        (_, i) => i !== index
      );
      setData({ ...data, dailyTimings: updateddailyTimings });
      if (activeRow === index) setActiveRow(null); // 👈 close if deleted
    }
  };

  return (
    <div style={{}} className="col-12 row ">
      <div className="col-12 row" style={{ marginBottom: "20px" }}>
        <div className="col-4">
          <label>Add Title</label>
          <input
            className="f_input"
            type="text"
            value={data?.title?.["english"]}
            onChange={(e) =>
              setData({
                ...data,
                title: { ...data.title, english: e.target.value },
              })
            }
            style={{
              display: "block",
              marginTop: "5px",
              padding: "5px",
            }}
          />
        </div>
        <div className="col-4">
          <label>Add Simplified Chinese Title</label>
          <input
            className="f_input"
            type="text"
            value={data?.title?.["simplified_chinese"]}
            onChange={(e) =>
              setData({
                ...data,
                title: { ...data.title, simplified_chinese: e.target.value },
              })
            }
            style={{
              display: "block",
              marginTop: "5px",
              padding: "5px",
            }}
          />
        </div>
        <div className="col-4">
          <label>Add Traditional Chinese Title</label>
          <input
            className="f_input"
            type="text"
            value={data?.title?.["traditional_chinese"]}
            onChange={(e) =>
              setData({
                ...data,
                title: { ...data.title, traditional_chinese: e.target.value },
              })
            }
            style={{
              display: "block",
              marginTop: "5px",
              padding: "5px",
            }}
          />
        </div>
      </div>

      {/* dailyTimings */}
      {data?.dailyTimings?.map((row, index) => (
        <div
          key={index}
          className="row col-12"
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "15px",
            marginLeft: "10px",
            border: "1px solid black",
            borderRadius: "10px",
            padding: "10px",
          }}
          // 👈 click row to activate
        >
          {activeRow === index ? (
            <div className="col-lg-12 row" style={{ marginBottom: "10px" }}>
              {" "}
              <div
                className="col-lg-12"
                style={{
                  borderBottom: "1px solid black",
                  paddingBottom: "10px",
                }}
              >
                <ActionMobileDrop
                  title={` Availability/Opening Hours ${index + 1}`}
                  active={activeRow === index}
                  setActive={() => setActiveRow()}
                  handleDelete={() => deleteRow(index)}
                />
              </div>
              <div className="col-lg-2 col-md-12 col-sm-12 col-12">
                <label>Day</label>
                <input
                  type="number"
                  style={{
                    width: "100%",
                    height: "45px",
                    padding: "0 10px",
                    fontSize: "16px",
                    boxSizing: "border-box",
                  }}
                  value={row.day || ""}
                  onChange={(e) => handleChange(index, "day", e.target.value)}
                  disabled={activeRow !== index}
                  min={1}
                />
              </div>
              <Level2SailingDateInput
                data={row.rows || [{ description: "" }]}
                setData={(e) => handleChange(index, "rows", e)}
              />
            </div>
          ) : (
            <div
              onClick={() => setActiveRow(index)}
              className="col-12"
              style={{ color: "black", fontWeight: "bold", padding: "5px" }}
            >
              <ActionMobileDrop
                title={
                  row?.description ||
                  ` Availability/Opening Hours  ${index + 1}`
                }
                active={activeRow === index}
                setActive={() => setActiveRow(index)}
                handleDelete={() => deleteRow(index)}
              />
            </div>
          )}
        </div>
      ))}
      <button
        type="button"
        onClick={addRow}
        style={{ maxWidth: "100px", marginLeft: "10px" }}
        className="btn main_submit"
      >
        Add Item
      </button>
    </div>
  );
};

export default SailingInput;
